/* eslint-disable @typescript-eslint/no-explicit-any */
// src/app/contexts/i18n.tsx
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
    resources: {
        en: { translation: { "key_ngon_ngu": "English Language" } },
        vi: { translation: { "key_ngon_ngu": "Tiếng Việt" } },
    },
    lng: 'vi',
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
});

export default i18n;
